export default __webpack_public_path__ + "static/media/kitchen5-beforeB-2048w.b95116b2.webp";